// AUTO-GENERATED by infrastructure/scripts/write-angular-env.ts
// Do not edit manually. Re-run infrastructure/setup-dev.sh to regenerate.
import type { Environment } from './environment.model'

export const environment: Environment = {
  apiUrl: "https://sg4y30lxil.execute-api.us-east-1.amazonaws.com",
  wsUrl: "wss://sv7aw3brx6.execute-api.us-east-1.amazonaws.com/dev",
  cognito: {
    region: "us-east-1",
    userPoolId: "us-east-1_6fXJA3SmE",
    clientId: "46nak1hl1lk1q0t72k62m9s5c4",
    // Full Cognito domain hostname (no protocol). Example:
    //   road-segments-editor-dev-123456789.auth.us-east-1.amazoncognito.com
    domain: "road-segments-editor-dev-318459466905-v2.auth.us-east-1.amazoncognito.com",
  },
  roadExtractionTiles: {
    baseUrl: "https://road-extraction-tiles.accuterra.com",
    key: "FDsjeUpfCjhQrpTIg0Qbk5oGnb3jK832",
    slopeState: "co",
    probabilityState: "co",
    probabilityProject: "silverton",
    probabilityVersion: "0",
  },
}
